import { render } from "./WorkflowSettingsTemplateAi.vue?vue&type=template&id=67b34f8c&scoped=true"
import script from "./WorkflowSettingsTemplateAi.vue?vue&type=script&lang=js"
export * from "./WorkflowSettingsTemplateAi.vue?vue&type=script&lang=js"

import "./WorkflowSettingsTemplateAi.vue?vue&type=style&index=0&id=67b34f8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b34f8c"]])

export default __exports__